/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import DialogLogout from "components/DialogLogout";
import MenuItem from "./components/MenuItem";
import SwitchBlue from "components/SwitchBlue";

import {
	logoutRequest,
	onLoginWithFaceIdAction,
	offLoginWithFaceIdAction
} from "store/actions/LoginPageAction";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";
import { MENU_USER, getIsApp } from "config/constant";
import { connect } from "react-redux";
import { getValidateLoginFaceIdAction } from "store/actions/GlobalAction";
import { getCRMShopInfoDetail } from "store/actions/HomePageAction";
import { Grid } from "@material-ui/core";
import ImagesConfig from "components/ImagesConfig";

const UserPage = props => {
	const classes = useStyles();
	const history = useHistory();
	const [isOpenDialog, setOpenDialog] = useState(false);
	const {
		logout,
		infoShop,
		getCRMShopInfoDetail,
		onLoginWithFaceId,
		offLoginWithFaceId,
		getValidateLoginFaceId,
		isLoginFaceId
	} = props;

	const isApp = getIsApp();
	const [isFaceId, setIsFaceId] = useState(isLoginFaceId);
	const isLocal = window.location.host === "localhost:3000";

	useEffect(() => {
		getCRMShopInfoDetail();
		getValidateLoginFaceId();
	}, []);

	useEffect(() => {
		setIsFaceId(isLoginFaceId);
	}, [isLoginFaceId]);

	const handleMenu = type => {
		switch (type) {
			case "LOGOUT": {
				setOpenDialog(true);
				break;
			}
			case "HOTLINE": {
				if (typeof window !== undefined && isApp) {
					window?.ReactNativeWebView?.postMessage("CALL_PHONE");
				}
				break;
			}
			case "FACE_ID": {
				break;
			}
			default:
				history.push(MENU_USER[type]);
				break;
		}
	};

	const handleLogout = () => {
		setOpenDialog(false);
		if (typeof window !== undefined && isApp) {
			localStorage.clear();
			window?.ReactNativeWebView?.postMessage("LOGOUT");
		} else {
			logout();
		}
	};

	const onSuccessOnFaceId = secretKey => {
		window?.ReactNativeWebView?.postMessage(`BIOMETRICS_ON,1,${secretKey}`);
		getValidateLoginFaceId();
	};
	const onFailOnFaceId = () => {
		setIsFaceId(false);
		window?.ReactNativeWebView?.postMessage(`BIOMETRICS_ON,0`);
	};

	const onSuccessOffFaceId = () => {
		window?.ReactNativeWebView?.postMessage(`BIOMETRICS_OFF,1`);
		getValidateLoginFaceId();
	};
	const onFailOffFaceId = () => {
		setIsFaceId(true);
		window?.ReactNativeWebView?.postMessage(`BIOMETRICS_OFF,0`);
	};

	const handleOnFaceId = () => {
		const params = {
			onSuccess: onSuccessOnFaceId,
			onFail: onFailOnFaceId
		};
		onLoginWithFaceId(params);
	};

	const handleOffFaceId = () => {
		const params = {
			onSuccess: onSuccessOffFaceId,
			onFail: onFailOffFaceId
		};
		offLoginWithFaceId(params);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.bgUser }}>
				<Grid classes={{ root: classes.avatar }}>
					<ImagesConfig
						image={infoShop?.image}
						imageDefault={Images.icAvatar}
						width={100}
						height={100}
					/>
					<Grid classes={{ root: classes.userName }}>
						{infoShop?.owner ? infoShop?.owner : "_"}
					</Grid>
					<Grid classes={{ root: classes.level }}>
						<Grid
							style={{ background: infoShop?.backgroundColor }}
							classes={{ root: classes.bgLevel }}
						>
							<ImagesConfig
								image={
									isLocal
										? `https://sb-shop.kido.vn${infoShop?.logo}`
										: infoShop?.logo
								}
								imageDefault={Images.icCopperLevel1}
								width={20}
								height={20}
							/>
							{`Hạng ${infoShop?.levelName}` || "Hạng đồng"}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.bodyMenu }}>
				<Grid classes={{ root: clsx(classes.name, classes.title) }}>
					Thông tin tài khoản
				</Grid>
				<MenuItem
					icon={Images.icInfoUser}
					title="Thông tin cửa hàng"
					type="INFORMATION_STORE"
					handleMenu={handleMenu}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icAgreementMinutes}
					title="Biên bản thoả thuận"
					type="SIGNATURE"
					handleMenu={handleMenu}
					subIcon={
						infoShop?.isSignature
							? Images.icCheckCircle
							: Images.icWarningCircle
					}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icChangePassword}
					title="Thay đổi mật khẩu"
					type="CHANGE_PASSWORD"
					handleMenu={handleMenu}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icFaceId}
					title="Đăng nhập FaceID/TouchID"
					type="FACE_ID"
					handleMenu={handleMenu}
					subButton={
						<SwitchBlue
							checked={isFaceId}
							onChange={e => {
								setIsFaceId(e?.target?.checked);
								if (isFaceId) {
									handleOffFaceId();
								} else {
									handleOnFaceId();
								}
							}}
						/>
					}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icDeleteUser}
					title="Xóa tài khoản"
					type="DELETE_ACCOUNT"
					handleMenu={handleMenu}
				/>
			</Grid>
			<Grid classes={{ root: classes.bodyMenu }}>
				<Grid classes={{ root: clsx(classes.name, classes.title) }}>
					Hỗ trợ
				</Grid>
				<MenuItem
					icon={Images.icChat}
					title="Chat với nhân viên bán hàng"
					type="CHAT_WITH_SALESMAN"
					handleMenu={handleMenu}
					disable={true}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icNote}
					title="Liên hệ cho chúng tôi"
					type="FEED_BACK"
					handleMenu={handleMenu}
				/>
				<Grid classes={{ root: classes.border }} />
				<MenuItem
					icon={Images.icHotline}
					title="Hotline: 0986096600"
					type="HOTLINE"
					href={!isApp && "tel:0986096600"}
					handleMenu={handleMenu}
				/>
			</Grid>
			<Grid classes={{ root: classes.bodyMenu }}>
				<MenuItem
					icon={Images.icLogout}
					title="Đăng xuất"
					type="LOGOUT"
					handleMenu={handleMenu}
				/>
			</Grid>
			<DialogLogout
				open={isOpenDialog}
				handleClose={() => {
					setOpenDialog(false);
				}}
				handleLogout={handleLogout}
			/>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop,
		isLoginFaceId: state.globalReducer.isLoginFaceId
	};
};

const mapDispatchToProps = dispatch => {
	return {
		logout: () => {
			dispatch(logoutRequest());
		},
		getCRMShopInfoDetail: () => {
			dispatch(getCRMShopInfoDetail());
		},
		onLoginWithFaceId: data => {
			dispatch(onLoginWithFaceIdAction(data));
		},
		offLoginWithFaceId: data => {
			dispatch(offLoginWithFaceIdAction(data));
		},
		getValidateLoginFaceId: () => {
			dispatch(getValidateLoginFaceIdAction());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);
